import lazyLoadOnRender from '../../lazy/loadOnRender';

const VivaEngageNavigationHeaderPivot = () =>
  import(/* webpackChunkName: "4-feat-vivaengagenavigationheaderpivot" */ './VivaEngageNavigationHeaderPivot');

export default lazyLoadOnRender({ loader: VivaEngageNavigationHeaderPivot });
